import React from 'react';
import cx from 'classnames';
import { Table, Icon } from 'semantic-ui-react';
import { Dropdown, Menu, notification } from 'antd';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import AMAAftercareRuleStore from './Store';
import { TableEmptyMessage, TableFooterPagination, TableHeader } from '../../shared/table';
import { deleteAMAAftercareRule } from './Service';
import * as api from '../../../stores/api';

const columns = [
  { title: '' },
  { title: 'Name', sortKey: 'Name' },
  { title: 'Description', sortKey: 'Description' },
  { title: 'Duration (Days)' },
];

@observer
class AMAAftercareRuleTable extends React.Component {
  openModal = options => {
    return AMAAftercareRuleStore.toggleModal(true, options);
  };
  handleDelete = id => {
    AMAAftercareRuleStore.setFieldsValue({ loading: true });
    Promise.all([deleteAMAAftercareRule(id)])
      .then(([responseDelete]) => {
        if (responseDelete.status === 'success') {
          notification.destroy();
          notification.success({
            message: 'Success',
            description: 'Data has been deleted successfully.',
            duration: 3,
          });
          AMAAftercareRuleStore.refetch({}, true);
        }
      })
      .catch(() => {
        notification.destroy();
        notification.error({
          message: 'Error',
          description: 'An error occurred, please try again',
          duration: 3,
        });
      });
  };
  handleEdit = (id, record) => {
    return AMAAftercareRuleStore.toggleModal(true, {
      modalType: 'create',
      id,
      record,
    })();
  };
  renderTableAction = (id, record) => {
    return (
      <Dropdown
        trigger={['click']}
        overlay={
          <Menu>
            <Menu.Item onClick={() => this.handleEdit(id, record)}>Edit</Menu.Item>
            <Menu.Item
              onClick={this.openModal({
                modalType: 'confirm',
                message: 'Deleting this rule can affect current invoices. Are you sure to continue??',
                onOk: () => this.handleDelete(id),
              })}
              //onClick={() => this.handleDelete(id)}
            >
              Delete
            </Menu.Item>
          </Menu>
        }
      >
        <Icon name="ellipsis vertical" />
      </Dropdown>
    );
  };

  renderTableBody = (colSpan, data) => {
    if (!data || !data.itemList.length) {
      return <TableEmptyMessage colSpan={colSpan} />;
    }

    return data.itemList.map(({ Id, ...record }) => (
      <Table.Row key={Id}>
        {api.isAdmin() && <Table.Cell className="Cell-actions">{this.renderTableAction(Id, record)}</Table.Cell>}
        {api.isAdmin() ? (
          <Table.Cell className="Cell-link Cell-nowrap" selectable onClick={() => this.handleEdit(Id, record)}>
            <Link to="#" onClick={() => this.handleEdit(Id, record.Name)}>
              {record.Name}
            </Link>
          </Table.Cell>
        ) : (
          <Table.Cell className="Cell-nowrap">{record.Name}</Table.Cell>
        )}
        <Table.Cell>{record.Description}</Table.Cell>
        <Table.Cell>{record.Duration}</Table.Cell>
      </Table.Row>
    ));
  };

  handlePageClick = page => {
    AMAAftercareRuleStore.refetch({ curPage: page });
  };

  render() {
    const { loading, data, sortColumn, sortDirection } = AMAAftercareRuleStore;
    const colummn_ = api.isAdmin() ? columns : columns.filter(i => i.title);
    const colSpan = colummn_.length;

    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader
          columns={colummn_}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={AMAAftercareRuleStore.handleSort}
        />
        <Table.Body>{this.renderTableBody(colSpan, data)}</Table.Body>
        <TableFooterPagination
          colSpan={colSpan}
          currentPage={AMAAftercareRuleStore.curPage}
          totalPage={AMAAftercareRuleStore.totalPage}
          totalItems={AMAAftercareRuleStore.totalItems}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}
export default AMAAftercareRuleTable;
